import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LocationValidators {
  /**
   * State code validator
   * Must be exactly 2 uppercase characters
   */
  static stateCode(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const stateRegex = /^[A-Z]{2}$/;
      const isValid = stateRegex.test(control.value);

      return isValid ? null : { stateCode: { value: control.value } };
    };
  }

  /**
   * Latitude validator
   * Must be between -90 and 90
   */
  static latitude(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value && control.value !== 0) {
        return null;
      }

      const value = Number(control.value);
      const isValid = !isNaN(value) && value >= -90 && value <= 90;

      return isValid ? null : { latitude: { value: control.value } };
    };
  }

  /**
   * Longitude validator
   * Must be between -180 and 180
   */
  static longitude(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value && control.value !== 0) {
        return null;
      }

      const value = Number(control.value);
      const isValid = !isNaN(value) && value >= -180 && value <= 180;

      return isValid ? null : { longitude: { value: control.value } };
    };
  }

  /**
   * ZIP Code validator
   * Accepts formats: 12345 or 12345-6789
   */
  static zipCode(control: AbstractControl): ValidationErrors | null {
    const zipRegex = /^\d{5}(-\d{4})?$/;
    const valid = zipRegex.test(control.value);
    return valid ? null : { invalidZip: true };
  }

  /**
   * Returns a validator function that checks whether two form controls
   * within a FormGroup have matching values (commonly used for password confirmation).
   *
   * @param firstControlName - The name of the primary control (e.g. 'password').
   * @param secondControlName - The name of the control that must match the primary one (e.g. 'confirmPassword').
   * @returns A ValidatorFn that adds the `passwordMismatch` error key to the group or confirm control if the values differ.
   *
   * @example
   * ```ts
   * this.form = this.fb.group(
   *   {
   *     password: ['', Validators.required],
   *     confirmPassword: ['', Validators.required],
   *   },
   *   { validators: CustomValidators.matchControls('password', 'confirmPassword') }
   * );
   * ```
   */
}
